<script lang="ts">
    import {Button, Label, Select, Spinner} from "flowbite-svelte";
    import {onMount} from "svelte";
    import ContractCanvas from "$lib/partials/settings/ContractCanvas.svelte";

export let contract:any;

let activePage = 1
let loading = false;
let contractCanvas:any = null;
let image:any = null;


const setPage = (page:number) => {
    activePage = page
    loading = true

    const img = document.createElement("img");
    img.src = contract.bitmaps.find(x => x.page === activePage).location;
    img.onload = () => {

        image = img;
        loading = false

    };

}



onMount(() => {
    setPage(activePage)
})

</script>

<section>
    <h3 class="font-bold">{contract.name}</h3>
    <div class="flex gap-3">
        <div class="w-36">
            <Label class="space-y-2">
                <span>Page</span>
                <Select on:change={() => setPage(activePage)} placeholder="Page" bind:value={activePage} >
                    {#each contract.bitmaps as bitmap}
                        <option value={bitmap.page}>Page {bitmap.page}</option>
                    {/each}
                </Select>
            </Label>


        </div>
        <div class="flex-1 relative" >
            {#if loading}
                <div class="p-8">
                    <Spinner size={12} />
                </div>

            {:else}
                <ContractCanvas {image} {contract} page={activePage} bind:fields={contract.fields} />

            {/if}
        </div>

    </div>

</section>